var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-white rounded-[6px]"},[_c('div',{class:`tw-${_vm.color}-label-tag w-fit flex flex-row justify-center px-[8px] py-[4px] items-center rounded-[6px]`},[_c('div',{class:`tw-${_vm.color}-label-text font-bold text-[13px] leading-[18px] text-center`},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }